import React from 'react';
import { useHistory } from 'react-router';

import { IconInput } from 'shared/components/molecules/IconInput/IconInput';
import { Button } from 'shared/components/atoms/Button/Button';
import { Modal } from 'shared/components/organisms/Modal/Modal';
import { Spinner } from 'shared/components/atoms/Spinner/Spinner';

import { ReactComponent as Hexagon } from 'assets/icons/confirmation_hexagon.svg';

import locker from 'assets/icons/locker.svg';
import filled_locker from 'assets/icons/filled_locker.svg';

import { CodeStep, Confirmation, Container } from './_fourthRegisterGroup';

interface RegisterProps {
  challengeCode: string;
  setChallengeCode: Function;
  loading: boolean;
  showValidationModal: boolean;
  setShowValidationModal: Function;
  setCurrentStep: Function;
  checkChallengeCode: Function;
}

export const FourthRegisterGroup: React.FC<RegisterProps> = ({
  challengeCode,
  setChallengeCode,
  loading,
  showValidationModal,
  setShowValidationModal,
  setCurrentStep,
  checkChallengeCode,
}) => {
  const history = useHistory();

  const disableCondition = () => {
    return challengeCode.length < 3 ? true : false;
  };

  return (
    <Container className="group-wrapper">
      <CodeStep>
        <strong>Código de autenticação</strong>
        Enviamos um e-mail para fazer a verificação do usuário
        <span>Insira abaixo o código recebido</span>
      </CodeStep>

      <IconInput
        icon={locker}
        activeIcon={filled_locker}
        placeholder={'Código'}
        inputValue={challengeCode}
        setInputValue={setChallengeCode}
      />

      <Button
        onClick={() => checkChallengeCode()}
        disabled={disableCondition()}
      >
{/*       <Button
        onClick={() => setShowValidationModal(true)}
        disabled={disableCondition()}
      > */}
        {!loading ? 'Próximo' : <Spinner />}
      </Button>

      <Button backgroundColor='#C42D2D' onClick={() => setCurrentStep(1.1)}>
        Voltar
      </Button>

      <Modal
        showModal={showValidationModal}
        setShowModal={setShowValidationModal}
      >
        <Confirmation>
          <div className="confirmation__message">
            <b>Cadastro concluído !</b>
            Seu Cadastro foi concluído com sucesso!
          </div>
          <Hexagon className="confirmation__icon" />
          <Button onClick={() => history.push('login')}>Ok, vamos lá</Button>
        </Confirmation>
      </Modal>
    </Container>
  );
};
